export const PF_GRID_VIEW_LIMIT = 10;

export const SELLING_DEFAULT_SORT = '-lastUpdated';
export const BUYING_DEFAULT_SORT = '-lastSeen';
export const PRIVATE_DEFAULT_SORT = '-createdAt';
